import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Box, Button, Typography } from '@mui/material'
import hljs from 'highlight.js/lib/core';
import kotlin from 'highlight.js/lib/languages/kotlin';
import java from 'highlight.js/lib/languages/java';
import xml from 'highlight.js/lib/languages/xml';
import groovy from 'highlight.js/lib/languages/groovy';
import swift from 'highlight.js/lib/languages/swift';
import json from 'highlight.js/lib/languages/json';
import businessHelper from '../../helpers/business.helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DocComments from './DocComments';
import { DocumentationContext } from '../../context/DocumentationContext';
import MenuAccordion from '../containers/MenuAccordion';
import { HTML_ID_DOCUMENTATION_PAGE } from '../../config';
import DocCommentsIndex from './DocCommentsIndex';
import DocPageHandler from './DocPageHandler';
import DocForumComments from './DocForumComments';

hljs.registerLanguage('groovy', groovy);
hljs.registerLanguage('swift', swift);
hljs.registerLanguage('java', java);
hljs.registerLanguage('xml', xml);
hljs.registerLanguage('json', json);
hljs.registerLanguage('kotlin', kotlin);

export default function DocDisplayPage() {
    const context = useContext(DocumentationContext)
    const [pageIndex, setPageIndex] = useState('')
    const validateClick = useCallback((e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        let target = e.target as HTMLElement
        if (['a', 'A'].includes(target.tagName)) {
            e.preventDefault()
            context?.handlePageHiperLink((target as HTMLAnchorElement).href)
        }
    }, [])

    useEffect(() => {
        let divTarget = document.getElementById(HTML_ID_DOCUMENTATION_PAGE)
        divTarget?.querySelectorAll('pre').forEach((el) => {
            hljs.highlightElement(el as HTMLElement);
        });
        divTarget?.querySelectorAll('img').forEach((el) => {
            el.classList.add("img-placeholder");
            el.addEventListener('load', () => {
                el.classList.remove("img-placeholder");
            })
            el.addEventListener('error', () => {
                el.classList.remove("img-placeholder");
                el.alt = el.getAttribute('alias') || 'img'
            })
        });
        if (context?.referencedDoc?.withIndex) {
            setPageIndex(businessHelper.createPageIndex(divTarget))
        }
        context?.referencedDoc?.onPageLoaded?.(divTarget)
    }, [context?.page])

    return (<DocPageHandler>
        {context?.referencedDoc?.forum?.active && context.referencedDoc.forum.selected === 1 ? <DocForumComments /> :
            <div className='document-reference'>
                {context?.referencedDoc?.withIndex && <Typography variant='caption' component={'div'}
                    sx={{ height: '100%', flexDirection: 'column', borderRight: '1px dotted gray' }}
                    className='referenced-index'>
                    {context.handleBackHistory && <Box sx={{ paddingTop: '1rem' }}>
                        <Button
                            size='small'
                            color='primary'
                            startIcon={<FontAwesomeIcon icon="arrow-left" />}
                            onClick={context.handleBackHistory}
                        >
                            Regresar
                        </Button>
                    </Box>}
                    <Box className='referenced-index-content' sx={{ paddingTop: '0.5rem' }}>
                        <MenuAccordion header='Índice' avaible inactive={false} expanded icon='caret-right'>
                            <div
                                id="page-index"
                                dangerouslySetInnerHTML={{ __html: `${pageIndex}` }}
                                onClick={validateClick}
                            />
                        </MenuAccordion>
                        {context?.referencedDoc?.withComments && <MenuAccordion header='Comentarios' avaible inactive={false} icon='caret-right'>
                            <DocCommentsIndex action={validateClick} comments={context?.page?.comments || []} />
                        </MenuAccordion>}
                    </Box>
                </Typography>}
                <div className={`referenced-doc ${context?.referencedDoc?.theme}`} style={context?.referencedDoc?.withIndex ? {} : { width: '100%' }}>
                    {context?.page?.content && <div
                        id={HTML_ID_DOCUMENTATION_PAGE}
                        dangerouslySetInnerHTML={{ __html: `${context?.page.content}` }}
                        onClick={validateClick}
                    />}
                    {context?.referencedDoc?.withComments && <DocComments />}
                </div>
            </div>}
    </DocPageHandler>)
}